import { ProductOffering } from '@travelwin/core';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { NetworkSpeedTranslation } from '@/components/NetworkSpeedTranslation/NetworkSpeedTranslation';
import PlanPrice from '@/components/PlanCard/components/PlanPrice';

import PlanBenefitTile from '../../PlanBenefitTile/PlanBenefitTile';

export const PlanBenefits = ({
  planDetails: {
    bundle_validity,
    network_speed,
    data,
    texts,
    product_offering_pricing,
    call_minutes,
    call_minutes_international,
  },
  showPrice = true,
}: {
  planDetails: ProductOffering;
  showPrice?: boolean;
}) => {
  const { t } = useTranslation();

  const planBenefits = useMemo(() => {
    const benefitTiles = [];

    benefitTiles.push(
      <PlanBenefitTile
        key="bundle_validity"
        type="bundle_validity"
        value={`${bundle_validity} ${t('plan_card.days', ' Days')}`}
      />,
    );

    const features: string[] = [];
    if (data) {
      features.push(t('plan_card.data', 'Data'));
    }
    if (call_minutes || call_minutes_international) {
      features.push(t('plan_card.calls', 'Calls'));
    }
    if (texts) {
      features.push(t('plan_card.texts', 'SMS'));
    }

    if (features.length > 0) {
      benefitTiles.push(
        <PlanBenefitTile
          key="plan"
          type="plan"
          value={features.join('/\u200B')}
        />,
      );
    } else {
      benefitTiles.push(
        <PlanBenefitTile key="plan" type="empty" value="&nbsp;" />,
      );
    }
    if (network_speed) {
      benefitTiles.push(
        <PlanBenefitTile
          key="speed"
          type="speed"
          value={
            <NetworkSpeedTranslation
              translationKey={network_speed.description}
            />
          }
        />,
      );
    } else {
      benefitTiles.push(
        <PlanBenefitTile key="speed" type="empty" value="&nbsp;" />,
      );
    }
    if (showPrice) {
      benefitTiles.push(
        <PlanBenefitTile
          key="price"
          type="price"
          value={<PlanPrice pricing={product_offering_pricing[0]} />}
        />,
      );
    }

    return benefitTiles;
  }, [bundle_validity, t, network_speed, product_offering_pricing]);

  return <>{planBenefits}</>;
};
